<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<style lang="scss">
    @import './static/scss/app.scss';
</style>

<script>
    export default {
        name: 'App'
    };
</script>
